import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Typography,
} from "@mui/material";

interface VendorMismatchDialogProps {
  open: boolean;
  handleClose: () => void;
  onConnect: (selectedVendor: string) => void;
  onCancel: () => void;
}

const VendorMismatchDialog: React.FC<VendorMismatchDialogProps> = ({
  open,
  handleClose,
  onConnect,
  onCancel,
}) => {
  const [selectedValue, setSelectedValue] = useState("1");

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(event.target.value);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "& .MuiDialog-container": {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh", 
        },
        "& .MuiDialog-paper": {
          width: "400px",
          height: "auto", 
          borderRadius: "4px",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: "bold",
          flexDirection: "column",
        }}
      >
        <Typography sx={{ fontWeight: 700, fontSize: "16px", mb: 1 }}>
          Multiple vendor’s asset found
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "#666666",
            textAlign: "center", 
            fontWeight: 500,
            fontSize: "13px",
          }}
        >
          You have uploaded multiple vendor’s asset, select one option to
          proceed
        </Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <FormControl>
          <RadioGroup value={selectedValue} onChange={handleRadioChange}>
            <FormControlLabel
              value="1"
              control={<Radio />}
              sx={{ mb: 2 }} 
              label={
                <div>
                  <Typography
                    variant="body2"
                    sx={{ color: "#10111E", fontWeight: "bold" }}
                  >
                    Selected Vendor{" "}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#8480AD" }}>
                    Removes assets from other vendors
                  </Typography>
                </div>
              }
            />
            <FormControlLabel
              value="0"
              control={<Radio />}
              sx={{ mb: 2 }} 
              label={
                <div>
                  <Typography
                    variant="body2"
                    sx={{ color: "#10111E", fontWeight: "bold" }}
                  >
                    Multiple Vendors
                  </Typography>{" "}
                  <Typography variant="body2" sx={{ color: "#8480AD" }}>
                    Includes assets from other vendors
                  </Typography>
                </div>
              }
            />
          </RadioGroup>
        </FormControl>
      </DialogContent>

      <DialogActions
         sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "row",
            mb:3,
            gap:3
          }}
      >
        <Button
          onClick={() => {
            console.log("User clicked cancel button");
            onCancel(); 
            handleClose();
          }}
          color="primary"
          variant="outlined"
          size="large"
          sx={{width:150}}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            console.log("User clicked connect button");
            onConnect(selectedValue); 
            handleClose();
          }}
          variant="contained"
          sx={{width:150}}
        >
          Connect
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VendorMismatchDialog;
